export default __webpack_public_path__ + "static/media/image1.e97f7adb.jpg";